<template>
  <div class="additional-setting-wrapper">
    <b-button v-b-toggle.setting-collapse variant="primary" class="toggle-btn">
      <div class="toggle-btn-text">Zusätzliche Einstellungen</div>
      <img src="../../assets/img/form-settings-expand.svg" />
    </b-button>
    <b-collapse v-model="isVisibleSettings" id="setting-collapse">
      <form ref="additionalSettingFormRef">
        <template v-if="isFieldVisible(ADDITIONAL_SETTINGS_ENUM.FORMAT_NUMBER)">
          <div class="form-item">
            <label for="counting-decimal">Dezimalzahlen zählen:</label>
            <p>{{ element.settings.toFixed }}</p>
            <input
              id="counting-decimal"
              name="counting-decimal"
              type="range"
              min="0"
              max="6"
              v-model.number="element.settings.toFixed"
              :disabled="!isUserHasAccess"
            />
          </div>
          <div class="form-item">
            <label for="decimal-separator">Dezimaltrennzeichen:</label>
            <input
              id="decimal-separator"
              name="decimal-separator"
              type="text"
              v-model="element.settings.decSep"
              v-b-tooltip.hover
              title="Nur die Zeichen  .  ,  und  '  sind in diesem Eingabefeld erlaubt."
              @input="handleInputEvent($event, 'decimalSeparator')"
              :disabled="!isUserHasAccess"
            />
          </div>
          <div class="form-item">
            <label for="thousand-separator">Tausendertrennzeichen:</label>
            <input
              id="thousand-separator"
              name="thousand-separator"
              type="text"
              v-model="element.settings.thSep"
              v-b-tooltip.hover
              title="Nur die Zeichen  .  ,  und  '  sind in diesem Eingabefeld erlaubt."
              @input="handleInputEvent($event, 'thousandSeparator')"
              :disabled="!isUserHasAccess"
            />
          </div>
        </template>
        <div
          v-if="isFieldVisible(ADDITIONAL_SETTINGS_ENUM.PLACEHOLDER)"
          class="form-item"
        >
          <label for="placeholder">Platzhalter:</label>
          <input
            id="placeholder"
            name="placeholder"
            type="text"
            v-model="element.settings.placeholder"
            :disabled="!isUserHasAccess"
          />
        </div>
        <div
          v-if="isFieldVisible(ADDITIONAL_SETTINGS_ENUM.DESCRIPTION)"
          class="form-item"
        >
          <label for="description">Beschreibung:</label>
          <textarea
            id="description"
            name="description"
            placeholder="Fügen Sie eine Beschreibung hinzu..."
            type="text"
            v-model="element.settings.description"
            :disabled="!isUserHasAccess"
          />
        </div>
        <template v-if="isFieldVisible(ADDITIONAL_SETTINGS_ENUM.MIN_MAX)">
          <div class="form-item">
            <label for="minimum">Minimum:</label>
            <input
              id="minimum"
              name="minimum"
              type="number"
              :key="getElementMax('min')"
              :max="getElementMax('min')"
              :min="getElementMin('min')"
              :required="isReqiredMinimum"
              v-model.number="element.settings.min"
              :disabled="!isUserHasAccess"
              @invalid="onHandleInvalid"
              @input="
                handleInputEvent($event, ADDITIONAL_SETTINGS_ENUM.MIN_MAX)
              "
            />
          </div>
          <div class="form-item">
            <label for="maximum">Maximum:</label>
            <input
              id="maximum"
              name="maximum"
              type="number"
              :key="getElementMin('max')"
              :max="getElementMax('max')"
              :min="getElementMin('max')"
              v-model.number="element.settings.max"
              :disabled="!isUserHasAccess"
              @invalid="onHandleInvalid"
              @input="
                handleInputEvent($event, ADDITIONAL_SETTINGS_ENUM.MIN_MAX)
              "
            />
          </div>
        </template>
        <div
          v-if="isFieldVisible(ADDITIONAL_SETTINGS_ENUM.SELECT)"
          class="form-item"
        >
          <label for="Type">Wert:</label>
          <GeneralDropdown
            className="database-dropdown"
            class=""
            :disabled="!isUserHasAccess"
          >
            <template v-slot:selectFilter>
              {{ getSelectedOption }}
            </template>
            <template v-slot:optionData>
              <b-dropdown-item
                v-for="option in element.options"
                :key="option.value"
                @click="changeOptionValue(option.value)"
                class="group-items"
                :class="{ selected: element.value === option.value }"
              >
                {{ option.label }}
              </b-dropdown-item>
            </template>
          </GeneralDropdown>
        </div>
        <div
          v-if="isFieldVisible(ADDITIONAL_SETTINGS_ENUM.TABINDEX)"
          class="form-item"
        >
          <label for="tabindex">Tabindex:</label>
          <input
            id="tabindex"
            name="tabindex"
            type="number"
            placeholder="Dieser Wert ist optional"
            v-model="element.settings.tabindex"
            :disabled="!isUserHasAccess"
          />
        </div>
        <div
          v-if="isFieldVisible(ADDITIONAL_SETTINGS_ENUM.PATTERN)"
          class="form-item"
        >
          <label for="pattern">Pattern:</label>
          <input
            id="pattern"
            name="pattern"
            type="text"
            placeholder="Eingabemuster hinzufügen"
            v-model="element.settings.pattern"
            :disabled="!isUserHasAccess"
          />
        </div>
        <div
          v-if="isFieldVisible(ADDITIONAL_SETTINGS_ENUM.ERROR_MESSAGE)"
          class="form-item"
        >
          <label for="error-message">Error mesaage:</label>
          <input
            id="error-message"
            name="error-message"
            type="text"
            placeholder="Fehlermeldung"
            v-model="element.settings.errorMessage"
            :disabled="!isUserHasAccess"
          />
        </div>
        <div
          v-if="isFieldVisible(ADDITIONAL_SETTINGS_ENUM.DECIMAL_PLACE)"
          class="form-item"
        >
          <label for="decimal-place">Dezimalstellen:</label>
          <p>
            Erhöhungsschritte oder gewünschte Anzahl an Dezimalen definieren.
            Für Standardeinstellungen Feld leer lassen.
          </p>
          <input
            id="decimal-place"
            name="decimal-place"
            type="number"
            step="any"
            min="0"
            v-model="element.settings.step"
            :disabled="!isUserHasAccess"
          />
        </div>
        <div
          class="form-item"
          v-if="isFieldVisible(ADDITIONAL_SETTINGS_ENUM.TOOLTIP)"
        >
          <label for="element-tooltip">Tooltip:</label>
          <input
            id="element-tooltip"
            name="element-tooltip"
            type="text"
            placeholder="Zusatzinformation, die beim Hover angezeigt wird"
            v-model.trim="element.settings.tooltip"
            :disabled="!isUserHasAccess"
          />
        </div>
      </form>
    </b-collapse>
  </div>
</template>

<script>
import {
  showInputInvalidCustomMessage,
  showToaster,
} from '../../utils/helpers';
import GeneralDropdown from '../core/general-dropdown.vue';
import { ADDITIONAL_SETTINGS_ENUM } from '@/utils/constants/FormBuilderConstants.js';

export default {
  data() {
    return {
      isVisibleSettings: false,
      ADDITIONAL_SETTINGS_ENUM,
    };
  },
  props: {
    element: Object,
    isUserHasAccess: { type: Boolean, default: true },
  },
  methods: {
    isFieldVisible(fieldName) {
      if (fieldName === this.ADDITIONAL_SETTINGS_ENUM.PLACEHOLDER) {
        return [
          'text',
          'email',
          'number',
          'textarea',
          'formatted_number',
          'model',
        ].includes(this.element.type);
      } else if (fieldName === this.ADDITIONAL_SETTINGS_ENUM.TABINDEX) {
        return !this.element.settings?.layoutItem;
      } else if (
        [
          this.ADDITIONAL_SETTINGS_ENUM.PATTERN,
          this.ADDITIONAL_SETTINGS_ENUM.ERROR_MESSAGE,
        ].includes(fieldName)
      ) {
        return this.element.type === 'text';
      } else if (fieldName === this.ADDITIONAL_SETTINGS_ENUM.DECIMAL_PLACE) {
        return ['range', 'number'].includes(this.element.type);
      } else if (fieldName === this.ADDITIONAL_SETTINGS_ENUM.MIN_MAX) {
        return ['range', 'number', 'checkbox'].includes(this.element.type);
      } else if (fieldName === this.ADDITIONAL_SETTINGS_ENUM.FORMAT_NUMBER) {
        return this.element.type === 'formatted_number';
      } else if (fieldName === this.ADDITIONAL_SETTINGS_ENUM.DESCRIPTION) {
        return !['title', 'hidden', 'model', 'textblock'].includes(
          this.element.type
        );
      } else if (fieldName === this.ADDITIONAL_SETTINGS_ENUM.SELECT) {
        return this.element.type === 'select';
      } else if (fieldName === this.ADDITIONAL_SETTINGS_ENUM.TOOLTIP) {
        return !['title', 'hidden', 'model'].includes(this.element.type);
      } else {
        return false;
      }
    },
    showDecThErrorToaster() {
      showToaster(
        this,
        'Tausendertrennzeichen und Dezimaltrennzeichen dürfen nicht identisch sein',
        'Fehlerhaft !',
        'danger'
      );
    },
    handleInputEvent(event, fieldName) {
      const fieldValue = event.target.value;
      if (this.ADDITIONAL_SETTINGS_ENUM.MIN_MAX === fieldName) {
        showInputInvalidCustomMessage(event);
        if (
          this.element.type === 'checkbox' &&
          this.element.settings.min > 0 &&
          !this.element.settings.required
        ) {
          this.element.settings.required = true;
          this.element.settings.max = this.element.options.length;
        }
      } else if (
        ['decimalSeparator', 'thousandSeparator'].includes(fieldName)
      ) {
        const isValidInput = /^[,.']*$/.test(fieldValue);
        const isDecimalSeparator = fieldName === 'decimalSeparator';
        if (fieldValue && isValidInput) {
          if (
            isDecimalSeparator &&
            fieldValue === this.element.settings.thSep
          ) {
            this.element.settings.decSep =
              this.element.settings.thSep !== ',' ? ',' : '.';
            this.showDecThErrorToaster();
            return;
          } else if (
            !isDecimalSeparator &&
            fieldValue === this.element.settings.decSep
          ) {
            this.element.settings.thSep =
              this.element.settings.decSep !== '.' ? '.' : ',';
            this.showDecThErrorToaster();
            return;
          }
        }
        if (!isValidInput || fieldValue.length > 1) {
          isDecimalSeparator
            ? (this.element.settings.decSep = '')
            : (this.element.settings.thSep = '');
        }
      }
    },
    onHandleInvalid(event) {
      showInputInvalidCustomMessage(event);
    },

    getElementMin(type) {
      if (
        ['range', 'number'].includes(this.element.type) &&
        this.element.settings.min &&
        type === 'max'
      ) {
        return Number(this.element.settings.min) + 1;
      } else if (this.element.type === 'checkbox') {
        return type === 'min'
          ? this.element.settings.required
            ? 1
            : 0
          : this.element.settings.min;
      }
      return null;
    },
    getElementMax(type) {
      if (
        ['range', 'number'].includes(this.element.type) &&
        this.element.settings.max &&
        type === 'min'
      ) {
        return Number(this.element.settings.max) + -1;
      } else if (this.element.type === 'checkbox') {
        return this.element.options.length;
      }
      return null;
    },
    formValidate() {
      const form = this.$refs.additionalSettingFormRef;
      if (!form.checkValidity()) {
        this.isVisibleSettings = true;
        form.reportValidity();
        const firstInvalid = form.querySelector(':invalid');
        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalid.focus();
        }
        return false;
      }
      return true;
    },
    changeOptionValue(value) {
      this.$set(this.element, 'value', value);
    },
  },
  computed: {
    isReqiredMinimum() {
      return this.element.type === 'checkbox' && this.element.settings.required;
    },
    getSelectedOption() {
      if (this.element.type === 'select') {
        return (
          this.element.options.find((op) => op.value === this.element.value)
            ?.label || 'wähle eine Option'
        );
      }
      return 'wähle eine Option';
    },
  },
  components: { GeneralDropdown },
};
</script>

<style scoped>
.additional-setting-wrapper {
  padding-bottom: 23px;
}
.additional-setting-wrapper .toggle-btn,
.additional-setting-wrapper .toggle-btn:active {
  background: #ffffff;
  border: none;
  padding: 0;
  box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.additional-setting-wrapper .toggle-btn .toggle-btn-text {
  font-family: OpenSans-SemiBold;
  font-weight: 600;
  font-size: 13px;
  line-height: 36px;
  letter-spacing: 0.3px;
  vertical-align: middle;
  color: #484e5e;
}

.additional-setting-wrapper .toggle-btn img {
  transition: 0.1s ease-in-out;
  margin-left: 9px;
}
.additional-setting-wrapper .toggle-btn.not-collapsed img {
  transform: rotate(180deg);
}

.additional-setting-wrapper .collapse form {
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  gap: 16px;
}

.additional-setting-wrapper .form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.additional-setting-wrapper .form-item label {
  font-size: 13px;
  font-family: Open Sans, open-sans, sans-serif;
  color: #464d5d;
}
.additional-setting-wrapper .form-item p {
  margin: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #919191;
}
.additional-setting-wrapper .form-item textarea,
.additional-setting-wrapper .form-item input {
  padding: 9px 12px;
  border: 1px solid #dee3e9;
  color: #464d5d !important;
  background: #ffffff;
  border-radius: 2px;
  width: 100%;
  max-width: 100%;
  height: auto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.additional-setting-wrapper .form-item textarea {
  height: 150px;
  resize: none;
  overflow: scroll;
}

.additional-setting-wrapper .form-item:has(input:invalid) input {
  background-color: #ff8790;
}
</style>
